import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Intro from "../components/Intro";
import About from "../components/About";
import Pranic from "../components/Pranic";
import Tachyon from "../components/Tachyon";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import PageSeo from "../components/PageSeo";
import { useLanguage } from "../context/LanguageContext";

const Home = () => {
  const { lang } = useLanguage();

  return (
    <div className="bg-brand-cream overflow-x-hidden">
      <PageSeo lang={lang} />
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <About />
        <Pranic />
        <Tachyon />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
